import { useUrlFriendlyToParameters } from "helpers/urlFriendly";
import { useQueryClient } from "react-query";
import { useState, useEffect } from "react";
import { getSportCodeObject } from "components/common/SportCode";
import { Button } from "react-bootstrap";
import Label from "components/general/Label";
import { Modal } from "react-bootstrap";


const CourseImage = ({ data }) => {
    const [dataSportCodes, setDataSportCodes] = useState()
    const queryClient = useQueryClient();
    const { mirs_competition, mirs_language, mirs_discipline } = useUrlFriendlyToParameters()
    const [show, setShow] = useState(false);

    useEffect(() => {
        setDataSportCodes(queryClient.getQueryData(["SportCodes", mirs_competition, mirs_language])?.sportCodes);
    }, [])

    const courseSportCode = data?.results?.extendedInfos?.find(ei => ei?.ei_code === 'COURSE_SAILED')?.ei_value;
    const course = getSportCodeObject(dataSportCodes, mirs_discipline, '@Course', courseSportCode)?.description

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);


    return (
        <>
            <div className='img-fluid courseimage-bk'>
                <Button variant="light" onClick={handleShow}>
                    <picture >
                        <img className="d-block mx-auto img-fluid h-100" alt={course} title={course} src={`/assets/images/sal/${courseSportCode}.jpg`} />
                    </picture>
                </Button>
            </div>
            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>{course}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className='img-fluid w-100'>
                        <picture >
                            <img className="d-block mx-auto img-fluid h-100" alt={course} title={course} src={`/assets/images/sal/${courseSportCode}.jpg`} />
                        </picture>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        <Label data={'LabelClose'} />
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default CourseImage;